<template>
  <!-- <img
    :src="`../../../assets/icons/${props.name}.svg`"
    :class="className" /> -->
  <component
    :is="icon"
    :class="className" />
</template>

<script setup>
import { computed, defineAsyncComponent } from "vue";
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: null
  },
  upsideDown: {
    type: Boolean,
    default: false
  }
});

const className = computed(() => {
  let classes = "";
  if (props.upsideDown) classes += "icon-upside-down";
  if (props.color) classes += ` icon-${props.color}`;
  return classes;
});

const icon = computed(() =>
  defineAsyncComponent(() => import(`../../../assets/icons/${props.name}.svg`))
);
</script>

<style scoped>
.icon-white {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7484%)
    hue-rotate(186deg) brightness(129%) contrast(104%);
}

.icon-upside-down {
  transform: rotate(180deg);
}
</style>
